import Vue from 'vue'
import Vuex from 'vuex'
import {
    view,
    nav
} from '@/config/store.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        main: {
            state: {
                title: '',
                back: false,
            },
        },
        view,
        nav
    },
})